export const isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
/**
 * 是否是浏览器
 */
export const isWeb = !isNode;
